<div class="user-modal">
  <app-spinner *ngIf="loading"></app-spinner>

  <form #userForm="ngForm" *ngIf="!loading" (submit)="saveUserProfile()">
    <h2 md-dialog-title>
      <span *ngIf="user.id">Edit {{ user.login }}</span>
      <span *ngIf="!user.id">New user</span>
    </h2>
    <md-dialog-content>
      <div class="sections">
        <div class="section" *ngIf="editMode">
          <h4>User information</h4>
          <div class="subsection">
            <md-form-field>
              <input
                mdInput
                name="login"
                placeholder="Login or Email address"
                [(ngModel)]="user.login"
                required="true"
              />
            </md-form-field>
          </div>
          <div class="subsection">
            <md-checkbox
              name="external"
              [(ngModel)]="user.isExternal"
              [disabled]="user.id"
              >External</md-checkbox
            >
          </div>
          <div class="subsection" *ngIf="!user.isFromActiveDirectory">
            <div *ngIf="editUser && !user.resetPassword">
              <button md-raised-button type="button" (click)="resetPassword()">
                <md-icon>refresh</md-icon>
                Reset Password
              </button>
            </div>
            <md-form-field *ngIf="!editUser || user.resetPassword">
              <input
                mdInput
                name="passwordUser"
                type="text"
                placeholder="Password"
                [(ngModel)]="user.password"
                required="true"
                (keyup)="checkPasswordPolicy()"
              />
            </md-form-field>
            <br />
            <span class="error-message" *ngIf="isPasswordInvalid"
              >Must be at least 12 characters</span
            >
          </div>
        </div>
        <div class="section" *ngIf="!editMode">
          <h4>User information</h4>
          <div class="subsection"><b>Login : </b>{{ user.login }}</div>
          <div class="subsection">
            <b>External : </b
            >{{ !user.isFromActiveDirectory | booleanToString }}
          </div>
          <div class="subsection" *ngIf="!user.isFromActiveDirectory">
            <b>Password : </b>{{ user.password }}
          </div>
        </div>
        <div class="section">
          <h4>User profiles</h4>
          <div *ngIf="editMode">
            <md2-autocomplete
              [items]="
                userProfiles | excludeByList: user.profiles:user.profiles.length
              "
              item-text="value"
              item-value=""
              [(ngModel)]="selectedUserProfile"
              (change)="profileSelected($event)"
              min-length="0"
              name="profiles"
              placeholder="Select user profiles"
            >
            </md2-autocomplete>
            <hr />
          </div>
          <md-chip-list>
            <md-chip
              *ngFor="let profile of user.profiles"
              (click)="removeProfile(profile)"
              >{{ profile.value }}</md-chip
            >
          </md-chip-list>
        </div>
        <div class="section">
          <h4>Languages</h4>
          <div class="subsection">
            <md2-select
              placeholder="Languages available"
              name="languages"
              [(ngModel)]="user.languages"
              [multiple]="true"
              (change)="changeUserLanguages()"
              *ngIf="editMode"
              required="true"
            >
              <md2-option [value]="allLanguage">SELECT ALL</md2-option>
              <md2-option
                *ngFor="let language of languages | orderBy: 'value':'asc'"
                [value]="language"
              >
                {{ language.value }}</md2-option
              >
            </md2-select>
            <ul *ngIf="!editMode">
              <li *ngFor="let language of user.languages">
                {{ language.value }}
              </li>
            </ul>
          </div>
          <div class="subsection">
            <h5>
              <span *ngIf="!editMode && user.defaultLanguage">{{
                user.defaultLanguage.value
              }}</span>
            </h5>
            <span
              *ngIf="
                editMode && (!user.languages || user.languages.length === 0)
              "
              ><i>select at least one language</i></span
            >
            <md2-select
              required="true"
              placeholder="Default language"
              name="defaultLanguage"
              [(ngModel)]="user.defaultLanguage"
              *ngIf="editMode && user.languages && user.languages.length > 0"
            >
              <md2-option
                *ngFor="
                  let language of user.languages
                    | orderBy: 'value':'asc'
                    | filterDropdown: -1
                "
                [value]="language"
                >{{ language.value }}</md2-option
              >
            </md2-select>
            <div class="subsection">
              <md-checkbox name="isEditor" [(ngModel)]="user.isEditor"
                >Is an editor</md-checkbox
              >
            </div>
          </div>
        </div>
      </div>
      <hr />
      <app-checkbox-table
        #checkboxTable
        [editMode]="editMode"
        [profiles]="user.profiles"
        [privileges]="user.userPrivileges"
        (userPrivilegesUpdated)="userPrivilegesUpdated($event)"
      ></app-checkbox-table>
    </md-dialog-content>
    <md-dialog-actions *ngIf="editMode">
      <div>
        <button
          md-raised-button
          color="warn"
          (click)="deleteUser()"
          type="button"
          *ngIf="user.id"
        >
          <md-icon>delete</md-icon>
          Delete
        </button>
      </div>
      <div>
        <button md-raised-button md-dialog-close type="button">
          <md-icon>cancel</md-icon>
          Cancel
        </button>
        <button
          md-raised-button
          color="accent"
          type="submit"
          [disabled]="
            !userForm.valid ||
            (user.defaultLanguage == null &&
              user.profiles.length === 0 &&
              user.userPrivileges.length === 0) ||
            isPasswordInvalid
          "
        >
          <md-icon>save</md-icon>
          Save
        </button>
      </div>
    </md-dialog-actions>
    <md-dialog-actions *ngIf="!editMode">
      <div></div>
      <div>
        <button md-raised-button md-dialog-close type="button">Close</button>
      </div>
    </md-dialog-actions>
  </form>
</div>



// WEBPACK FOOTER //
// ./src/app/modals/user-modal/user-modal.component.html